import { useEffect, useRef, useState } from 'react';
import { apiRequest } from '../services/apiClient';

/**
 * Loads the locations the authenticated caller can access. Reuses
 * the existing /api/locations endpoint which already filters by
 * canAccessLocation server-side. Returns `[]` while loading or on
 * error so consumers can keep rendering without explicit guards.
 */
export function useAccessibleLocations() {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const abortRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    abortRef.current = controller;
    setIsLoading(true);
    setError('');
    apiRequest('/api/locations', { signal: controller.signal })
      .then((data) => {
        if (controller.signal.aborted) return;
        setLocations(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        if (controller.signal.aborted) return;
        setError(err?.message || 'Unable to load locations.');
        setLocations([]);
      })
      .finally(() => {
        if (!controller.signal.aborted) setIsLoading(false);
      });
    return () => controller.abort();
  }, []);

  return { locations, isLoading, error };
}
